import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spare-parts-list',
  templateUrl: './spare-parts-list.component.html',
  styleUrls: ['./spare-parts-list.component.css']
})
export class SparePartsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
